import axios from 'axios';

import {
    USER_LOGIN_GRANT_TYPE, USER_LOGIN_VERSION, USER_LOGIN_PRODUCT_GUID, AWS_WAF_INTEGRATION
} from '~/common/utils/consts.js';

// eslint-disable-next-line no-unused-vars
const v4payload = {
    version: USER_LOGIN_VERSION,
    grant_type: USER_LOGIN_GRANT_TYPE,
    username: undefined, // gets populated in authUser
    password: undefined, // gets populated in authUser
    product_guid: USER_LOGIN_PRODUCT_GUID
};

const v5payload = {
    version: '5',
    authcode: undefined, // gets populated in authUser
    grant_type: 'identity_auth',
    redirect_uri: undefined, // gets populated in /server/handlers/api.js
    client_id: undefined // gets populated in /server/handlers/api.js
};

const getAwsWafResponse = async (payload, url) => {
    const config = {
        method: 'POST',
        body: JSON.stringify(payload)
    };
    return await window.AwsWafIntegration.fetch(url, config).then((resp) => {
        if (resp.ok) {
            return resp.json();
        }
        return resp.json().then((response) => {
            if (response?.Errors?.length) {
                return response;
            }
            throw new Error(response.error);
        });
    }).then((response) => {
        if (response.Errors) {
            return { data: false, error: { data: response } };
        }
        return { data: response, error: false };
    }).catch((err) => {
        return { data: false, error: err };
    });
};

/**
 * @todo: remove else and add if after removing v4
 */
export default async function authUser(params) {
    let config = {};
    let response = {};
    if (params.lmiAuthcode) {
        config = {
            ...v5payload,
            authcode: params.lmiAuthcode
        };
    } else if (params.username && params.password) {
        config = {
            grant_type: USER_LOGIN_GRANT_TYPE,
            username: params.username,
            password: params.password
        };

        if (AWS_WAF_INTEGRATION) {
            response = await getAwsWafResponse(config, '/token2/auth');
        } else {
            return axios.post('/token2/auth', config);
        }
    } else if (params.requestID) {
        config = {
            requestID: params.requestID,
            code: params.code
        };
        if (AWS_WAF_INTEGRATION) {
            response = await getAwsWafResponse(config, '/token2/validate');
        } else {
            return axios.post('/token2/validate', config);
        }
    } else if (params.lastRequestId) {
        config = {
            lastRequestId: params.lastRequestId
        };

        if (AWS_WAF_INTEGRATION) {
            response = await getAwsWafResponse(config, '/token2/newotp');
        } else {
            return axios.post('/token2/newotp', config);
        }
    } else {
        throw new Error('authUser wrong user params');
    }

    // Grab a new access token
    return new Promise((resolve, reject) => {
        if (response.data) {
            resolve({ data: response.data });
        } else {
            reject({ response: response.error });
        }
    });
}
